import ACCOMODATION_SEARCH from './accomodationSearch/accomodationSearch';
import DASHBOARD from './dashboard/dashboard';
import EVISITOR from './eVisitor/eVisitor';
import GUESTS from './guests/guests';
import { INVOICES } from './invoices/invoices';
import LITE from './lite/lite';
import RENTERS from './partners/partners';
import RENTALS_ACCOMMODATION from './rentals/accommodation';
import RENTALS_ATTRIBUTES from './rentals/attributes';
import RENTALS_AUTH from './rentals/auth';
import RENTALS_CHANNEL_MANAGER from './rentals/channelManager';
import RENTALS_CONTRACTS from './rentals/contracts';
import RENTALS_DISCOUNTS from './rentals/discounts';
import RENTALS_FEES_AND_TAXES from './rentals/feesAndTaxes';
import RENTALS_IMAGES from './rentals/images';
import RENTALS_LINKS from './rentals/links';
import RENTALS_MESSAGES from './rentals/messages';
import { NOTIFICATIONS } from './rentals/notifications';
import { RENTALS_PARTNERS } from './rentals/partners';
import RENTALS_PAYMENT_MODELS from './rentals/paymentModels';
import RENTALS_PROPERTIES from './rentals/properties';
import CONTRACT_PAYMENT_MODELS from './settings/paymentModels';
import SETTINGS_PROFILE from './settings/profile';
import { TASKS } from './tasks/tasks';
import TOURS_RESERVATIONS from './tours/reservations';
import UNITS_ATTRIBUTES from './units/attributes';
import UNITS_CHANNEL_MANAGER from './units/channelManager';
import UNITS_PRICE_LIST from './units/priceList';
import UNITS_PROPERTIES from './units/properties';
import UNITS_RESERVATIONS from './units/reservations';

export const QUERY_KEYS = {
  ...RENTALS_AUTH,
  ...RENTALS_ACCOMMODATION,
  ...RENTALS_ATTRIBUTES,
  ...RENTALS_DISCOUNTS,
  ...RENTALS_FEES_AND_TAXES,
  ...RENTALS_IMAGES,
  ...RENTALS_CONTRACTS,
  ...RENTALS_CHANNEL_MANAGER,
  ...RENTALS_PAYMENT_MODELS,
  ...RENTALS_PARTNERS,
  ...RENTALS_PROPERTIES,
  ...RENTALS_MESSAGES,
  ...UNITS_PRICE_LIST,
  ...UNITS_PROPERTIES,
  ...UNITS_ATTRIBUTES,
  ...UNITS_RESERVATIONS,
  ...UNITS_CHANNEL_MANAGER,
  ...TOURS_RESERVATIONS,
  ...GUESTS,
  ...RENTERS,
  ...SETTINGS_PROFILE,
  ...CONTRACT_PAYMENT_MODELS,
  ...EVISITOR,
  ...LITE,
  ...DASHBOARD,
  ...ACCOMODATION_SEARCH,
  ...TASKS,
  ...INVOICES,
  ...NOTIFICATIONS,
  ...RENTALS_LINKS,
};
